import { memo } from "react";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import "./LuggagePlaceholderLoader.scss";

const LuggagePlaceholderLoader = () => {
	return (
		<div className="luggage-placeholder">
			<div className="luggage-placeholder__loader">
				<i className="icon icon--bagage-cabine" />
				<LoaderBar />
			</div>
			<div className="luggage-placeholder__loader">
				<i className="icon icon--bagage-soute" />
				<LoaderBar />
			</div>
		</div>
	);
};

export default memo(LuggagePlaceholderLoader);
